<template>
  <div>
    <Cascader :checkStrictly="checkStrictly" :showalllevels="showalllevels" :placeholderLoad="placeholderLoad" 
      ref="toclearRef" :defaultProps="defaultProps" @setvalue="setvalue" :editType="editType"
      :bindata="treedata" :disabled="editType=='examine'||editType=='info'||editType=='return'"></Cascader>
  </div>
</template>

<script>
  import Cascader from "./Cascader"
	import { getListDictType, getListDict } from '@/http/DictManagement.js'

  export default {
    components: { Cascader },
    props: {
      editType: String, //修改类型 info：查看 add：新增 edit：编辑 examine：审批 return：回访
      dataOrigin:{//数据来源
        type: String, default: '0'
      },
      defaultList:{ 
        type: String, default: ""
      },
      placeholderLoad:{//提示 
        type: String, default: ""
      },
      showalllevels:{ 
        type: Boolean, default: false,
      },
      checkStrictly:{ 
        type: Boolean, default: false,  
      }
    },
    data() {
      return {
        defaultProps: {
          children: "childData",
          label: "dictName",
          value: "dictId"
        },
        treedata: [],
        values: ""
      }
    },
    methods: {
      //初始化分类
      init() {
        //加载状态数据源
        let params ={
          dictTypeCode: this.dataOrigin,
          vdnId:  JSON.parse(LocalStorage.getItem('obj')).vdnId
        }
        getListDict(params).then((res)=>{
          if(res && res.retCode == 1){
            this.treedata = res.data
          }
        })
      },
      setvalue(val) {
        this.values = val
      },
    },
    mounted() {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// CascaderList.vue?297f82f8